<template>
  <div v-if="activeTab === 'confirmation'" class="confirmation-card card shadow rounded-3 border">
    <div class="card-content card-body">
      <div class="status-icon">
        <i :class="workflowData.is_confirmed ? 'bi-check-circle-fill text-success' : 'bi-clock text-muted'"></i>
      </div>

      <h3 class="status-title" :class="workflowData.is_confirmed ? 'text-success' : 'text-muted'">
        {{ workflowData.is_confirmed ? 'Workflow Confirmed' : 'Pending Confirmation' }}
      </h3>

      <p class="status-description text-xs">
        {{ workflowData.is_confirmed
          ? 'This workflow has been successfully confirmed and is ready for use.'
          : 'This workflow is awaiting confirmation from the administrator.'
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationTab',
  props: {
    activeTab: {
      type: String,
      default: 'confirmation'
    },
    workflowData: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.confirmation-card {
  padding: 2rem;
  text-align: center;
  margin: 0 auto;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.status-icon {
  font-size: 3rem;
  margin-bottom: 0.5rem;
}

.status-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: #495057;
}

.status-description {
  color: #6c757d;
  line-height: 1.5;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .confirmation-card {
    padding: 1.5rem;
    margin: 0 1rem;
  }

  .status-icon {
    font-size: 2.5rem;
  }

  .status-title {
    font-size: 1.1rem;
  }
}
</style>
